// SuperadminDashboard.js
import React, { useEffect, useState, useCallback } from "react";
import {
  Container,Grid,Card,CardContent,Typography,IconButton,CircularProgress,Box,Tooltip,MenuItem,Select, FormControl, InputLabel
} from "@mui/material";
import { PieChart, Pie, Cell, Tooltip as ReTooltip } from "recharts";
import PeopleIcon from "@mui/icons-material/People";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import RefreshIcon from "@mui/icons-material/Refresh";
import axios from "axios";
import BASE_URL from "../config"; // adjust path if needed
const formatCurrency = (num) =>
  typeof num === "number"
    ? `₹${num.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
    : "₹0.00";
export default function SuperadminDashboard() {
  const [loading, setLoading] = useState(false);
  const [summary, setSummary] = useState({
    totalStudents: 0,
    totalAmount: 0,
    amountCollected: 0,
    totalConcession: 0,
  });
const [courses, setCourses] = useState([]);
const [academicYears, setAcademicYears] = useState([]);
const [classes, setClasses] = useState([]);
const [filters, setFilters] = useState({
  courseId: "",
  academicYearId: "",
  classId: ""
});
  const [error, setError] = useState(null);
  const fetchSummary = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const res = await axios.get(`${BASE_URL}/api/dashboard/summary`, { params: filters });
      setSummary(res.data);
    } catch (err) {
      console.error("Failed to load dashboard summary", err);
      setError("Unable to load dashboard data");
    } finally {
      setLoading(false);
    }
  }, [filters]);
// Fetch courses on mount
useEffect(() => {
  axios.get(`${BASE_URL}/api/scourses`).then(res => setCourses(res.data));
}, []);
// When course changes, load related academic years and classes
useEffect(() => {
  if (filters.courseId) {
    axios.get(`${BASE_URL}/api/sacademic-years/${filters.courseId}`).then(res => setAcademicYears(res.data));
    axios.get(`${BASE_URL}/api/sclasses/${filters.courseId}`).then(res => setClasses(res.data));
  } else {
    setAcademicYears([]);
    setClasses([]);
  }
}, [filters.courseId]);
  useEffect(() => {
    fetchSummary();
  }, [fetchSummary]);
  const cards = [
    {
      title: "Total Students",
      value: summary.totalStudents,
      icon: <PeopleIcon sx={{ fontSize: 40 }} />,
      color: "#1976d2",
      subtitle: "Active students",
    },
    {
      title: "Total Amount",
      value: formatCurrency(summary.totalAmount),
      icon: <MonetizationOnIcon sx={{ fontSize: 40 }} />,
      color: "#2e7d32",
      subtitle: "Sum of Total Fees",
    },
    {
      title: "Amount Collected",
      value: formatCurrency(summary.amountCollected),
      icon: <AccountBalanceWalletIcon sx={{ fontSize: 40 }} />,
      color: "#ed6c02",
      subtitle: "Payments received",
    },
    {
      title: "Concession",
      value: formatCurrency(summary.totalConcession),
      icon: <LocalOfferIcon sx={{ fontSize: 40 }} />,
      color: "#d32f2f",
      subtitle: "Total concessions granted",
    },
  ];
  const pendingAmount = summary.totalAmount - summary.amountCollected - summary.totalConcession;
const chartData = [
  { name: "Collected", value: summary.amountCollected },
  { name: "Concession", value: summary.totalConcession },
  { name: "Pending", value: pendingAmount }
];
const COLORS = ["#2e7d32", "#d32f2f", "#fbc02d"];
  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 6 }}>
       <Box display="flex" alignItems="center" justifyContent="space-between" mb={3}>
        <Typography variant="h4">Super Admin Dashboard</Typography>
        <Box>
          <Tooltip title="Refresh">
            <IconButton onClick={fetchSummary} disabled={loading}>
              <RefreshIcon />
            </IconButton>
          </Tooltip>
        </Box>
      </Box>
<Box display="flex" flexWrap="wrap" gap={2} mb={3}>
  <FormControl size="small" sx={{ minWidth: 150 }}>
    <InputLabel>Course</InputLabel>
    <Select
      value={filters.courseId}
      onChange={(e) => setFilters({ ...filters, courseId: e.target.value, academicYearId: "", classId: "" })}
    >
      <MenuItem value="">All</MenuItem>
      {courses.map(c => <MenuItem key={c.CourseID} value={c.CourseID}>{c.CourseName}</MenuItem>)}
    </Select>
  </FormControl>
  <FormControl size="small" sx={{ minWidth: 150 }} disabled={!filters.courseId}>
    <InputLabel>Academic Year</InputLabel>
    <Select
      value={filters.academicYearId}
      onChange={(e) => setFilters({ ...filters, academicYearId: e.target.value })}
    >
      <MenuItem value="">All</MenuItem>
      {academicYears.map(a => <MenuItem key={a.AcademicYearID} value={a.AcademicYearID}>{a.AcademicYearName}</MenuItem>)}
    </Select>
  </FormControl>
  <FormControl size="small" sx={{ minWidth: 150 }} disabled={!filters.courseId}>
    <InputLabel>Class</InputLabel>
    <Select
      value={filters.classId}
      onChange={(e) => setFilters({ ...filters, classId: e.target.value })}
    >
      <MenuItem value="">All</MenuItem>
      {classes.map(cl => <MenuItem key={cl.ClassID} value={cl.ClassID}>{cl.ClassName}</MenuItem>)}
    </Select>
  </FormControl>
</Box>
      {loading ? (
        <Box display="flex" justifyContent="center" alignItems="center" height={160}>
          <CircularProgress />
        </Box>
      ) : error ? (
        <Box>
          <Typography color="error">{error}</Typography>
        </Box>
      ) : (
        <Grid container spacing={3}>
          {cards.map((c, i) => (
            <Grid item xs={12} sm={6} md={3} key={i}>
              {/* <Card
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                  p: 2,
                  height: "100%",
                  boxShadow: 3,
                  borderRadius: 2,
                }}
              >
                <Box
                  sx={{
                    width: 64,
                    height: 64,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: 2,
                    bgcolor: `${c.color}22`, // subtle background
                    color: c.color,
                    flexShrink: 0,
                  }}
                >
                  {c.icon}
                </Box>
                <CardContent sx={{ flex: 1, py: 0 }}>
                  <Typography variant="subtitle2" color="text.secondary">
                    {c.title}
                  </Typography>
                  <Typography variant="h6" sx={{ mt: 0.5 }}>
                    {c.value}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    {c.subtitle}
                  </Typography>
                </CardContent>
              </Card> */}
              <Card
  sx={{
    display: "flex",
    flexDirection: "column", // 👈 stack items
    alignItems: "flex-start",
    gap: 2,
    p: 2,
    height: "100%",
    boxShadow: 3,
    borderRadius: 2,
  }}
>
  <Box
    sx={{
      width: 64,
      height: 64,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: 2,
      bgcolor: `${c.color}22`,
      color: c.color,
      flexShrink: 0,
    }}
  >
    {c.icon}
  </Box>
  <CardContent sx={{ width: "100%", p: 0 }}>
    <Typography variant="subtitle2" color="text.secondary">
      {c.title}
    </Typography>
    <Typography variant="h6" sx={{ mt: 0.5 }}>
      {c.value}
    </Typography>
    <Typography variant="caption" color="text.secondary" sx={{ whiteSpace: "normal" }}>
      {c.subtitle}
    </Typography>
  </CardContent>
</Card>

            </Grid>
          ))}
        </Grid>
      )}
 {/* PIE CHART */}
 <Box 
  mt={4} 
  display="flex" 
  justifyContent="center" 
  alignItems="center" 
  flexDirection="column"
>
  <Typography variant="h6" gutterBottom>
    Fee Breakdown
  </Typography>
  <PieChart width={400} height={300}>
    <Pie 
      data={chartData} 
      cx="50%" 
      cy="50%" 
      label 
      outerRadius={100} 
      dataKey="value"
    >
      {chartData.map((entry, index) => (
        <Cell key={`cell-${index}`} fill={COLORS[index]} />
      ))}
    </Pie>
    <ReTooltip />
  </PieChart>
</Box>
      {/* small footer / last refresh */}
      <Box mt={3} textAlign="right">
        <Typography variant="caption" color="text.secondary">
          Last updated: {new Date().toLocaleString()}
        </Typography>
      </Box>
    </Container>
  );
}
